// easyui-datebox.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, Input, Output, ViewChild, EventEmitter, ElementRef, forwardRef,
  AfterViewInit, ComponentFactoryResolver } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Globs } from '../globs';

declare let $: any;

@Component({
  selector: 'easyui-datebox',
  template: `
    <div [ngStyle]="style">
      <div #host>DEPRECATO</div>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EasyuiDateboxComponent),
      multi: true
    }
  ]
})
export class EasyuiDateboxComponent implements AfterViewInit, ControlValueAccessor {
  private host: any;
  private value: string;
  private onControlChange: Function;
  private onControlTouched: Function;
  @ViewChild('host') hostElement: ElementRef;
  @Input() style = {};
  @Input() width: number;
  @Input() height: number;
  @Input() mask: string;
  @Input() nxReadonly: string;

  constructor() {}

  ngAfterViewInit() {
    this.configura();
  }

  // eventi per ngModel

  public writeValue(value: string) {
    if (value === null) { return; }
    if (this.host) {
      this.host.datebox('setValue', value);
      this.value = value;
      // console.log('Input data: '+value)
    }
  }

  public registerOnChange(fn: any) {
    this.onControlChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onControlTouched = fn;
  }

  public readonly(on: boolean) {
    this.host.textbox('readonly', on);
  }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  // metodi

  public setFocus() {
    const innerHost = this.host.datebox('textbox');
    setTimeout(() => {
      innerHost.focus();
    });
  }

  // configurazione easyui
  private configura() {
    // configura l'elemento datebox di easyui
    this.host = $(this.hostElement.nativeElement);
    const options: any = {
      width: this.width ? this.width : '100%',
      height: this.height ? this.height : Globs.UI_HEIGHT,
      parser: (value: string) => {
        // il dm è in formato ISO
        // console.log('Sto parsando da '+value+' a '+dataIsoToJs(value))
        return Globs.dataIsoToJs(value);
      }
    };
    if (this.mask) {
      options.formatter = (value) => {
        // come viene vista nel campo
        // console.log('Sto formattando da '+value+' a '+= Globs.= Globs.dateFormat(value,this.mask))
        return Globs.dateFormat(value, this.mask);
      };
    }
    // in caso sia presente l'attribute nxReadonly
    if (this.nxReadonly === '') {
      this.host.datebox('readonly');
    }
    // crea l'elemento datebox
    this.host.datebox(options);
    // opzioni da applicare al 'vero' input che è interno a textbox
    const innerHost = this.host.datebox('textbox');
    innerHost.attr('spellcheck', false);
    innerHost.on('blur', () => {
      // let model = this.host.datebox('getValue')
      // console.log(model)
    });
    innerHost.on('keyup', () => {
      const model = this.host.datebox('getValue');
      // console.log('Model: '+model)
    });
    innerHost.on('keypress', (event) => {
      // filtra tutto tranne 1-9 e /
      if (((event.which < 48) || (event.which > 57)) && (event.which !== 47)) {
          event.which = 0;
          event.preventDefault();
          event.stopPropagation();
      }
    });
    // la lunghezza di una data
    const maxlen = this.mask ? this.mask.length : 10;
    innerHost.attr('maxlength', maxlen);
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-datebox.component.ts